<template>
  <div class="sc-message--system">
    <slot :message="data">
      {{data.text}}<p v-if="data.meta" class="sc-message--meta">{{data.meta}}</p>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
